import "./suppressInovuaNullUnhandledRejection";
import React from "react";
import { createRoot } from "react-dom/client";
import "./utils/i18n";
import "./index.css";
import { Provider as ReduxProvider } from "react-redux";
import { Provider as AlertProvider } from "react-alert";
import App from "./App";
import AppProvider from "./AppProvider";
import { Store } from "./redux/store";
import AlertTemplate from "./components/AlertTemplate";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <ReduxProvider store={Store}>
    <AppProvider>
      <AlertProvider template={AlertTemplate}>
        <App />
      </AlertProvider>
    </AppProvider>
  </ReduxProvider>
);
